<template>
    <div class="user-column-wrapper">
        <div
            class="user-question-data"
            :class="{ 'show-hidden': showHideStyle, 'single-text': !showHideStyle }"
            ref="questionText"
            @mousemove="moveHandle"
            @mouseout="outHandle"
        >
            <span class="text">
                <span class="translate" v-show="row.addData.lang && data" @click="showEnClick">{{ this.row.addData.lang.toUpperCase() }}</span>
                {{ data }}
            </span>
        </div>
        <div class="hover-cls" v-show="showDetail && showHideStyle && !isShowEn">{{ data }}</div>
        <div class="hover-cls" v-show="isShowEn">{{ row.addData.enUserQuestion }}</div>
    </div>
</template>

<script>
export default {
    name: "UserQuesColumn",
    props: ["data", "row"],
    data() {
        return {
            showDetail: false,
            lineHight: "",
            isShowEn: false
        };
    },
    computed: {
        showHideStyle() {
            if (this.lineHight > 48) {
                return true;
            } else {
                return false;
            }
        },
        isEn() {
            return this.row.addData.lang !== "en" ? true : false;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.lineHight = this.$refs.questionText.scrollHeight;
        });

        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        windowClick(event) {
            if (!this.$el.contains(event.target)) {
                this.isShowEn = false;
            }
        },
        moveHandle() {
            this.showDetail = true;
        },
        outHandle() {
            this.showDetail = false;
        },
        showEnClick() {
            // this.isShowEn = !this.isShowEn;
        }
    }
};
</script>

<style lang="less" scoped>
.user-column-wrapper {
    position: relative;

    .user-question-data {
        padding-right: 8px;
        word-break: break-all;
        word-wrap: break-word;
        overflow: hidden;
        height: 34px;
        align-items: center;
        line-height: 17px;
        .text {
            max-height: 34px;
        }
    }

    .single-text {
        display: flex;
    }

    .show-hidden {
        &:after {
            content: "...";
            width: 11px;
            position: absolute;
            top: 16px;
            right: 2px;
        }
    }

    .hover-cls {
        position: absolute;
        background: #fff;
        border-radius: 4px;
        padding: 5px 8px;
        top: auto;
        margin-top: 8px;
        width: 200%;
        text-align: center;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
        text-align: left;
        box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
        z-index: 1;
    }

    .translate {
        line-height: 14px;
        height: 14px;
        min-width: 26px;
        padding: 0 4px;
        box-sizing: border-box;
        text-align: center;
        background: #2ec2ff;
        color: #fff;
        border-radius: 7px;
        margin-right: 4px;
        cursor: pointer;
        white-space: nowrap;
    }
}
</style>
